import { FunctionComponent, ReactNode } from "react";

import * as Styled from "./styles";
import Flex from "../../layout/flex";
import { ReactComponent as ManifestLogoSvg } from "./manifest-logo.svg";
import { Arrow, Close } from "../icons";
import IconButton from "../icon-button";

export const HEADER_NAV_BUTTON_CLOSE = "HEADER_NAV_BUTTON_CLOSE";
export const HEADER_NAV_BUTTON_MENU = "HEADER_NAV_BUTTON_MENU";
export const HEADER_NAV_BUTTON_PREV = "HEADER_NAV_BUTTON_PREV";

export interface HeaderProps {
  // prevFunction?: () => void;
  navButton?: ReactNode | undefined;
  leftButton?: {
    icon: typeof HEADER_NAV_BUTTON_CLOSE | typeof HEADER_NAV_BUTTON_PREV;
    function: () => void;
  };
}

const Header: FunctionComponent<HeaderProps> = ({ leftButton = undefined, navButton = undefined }) => {
  return (
    <Styled.HeaderDiv>
      <Styled.HeaderContainer>
        <Flex $width="100%" $height="16px">
          <Styled.HeaderButton data-name="header-nav-button">
            {leftButton && (
              <IconButton onClick={leftButton.function} name="header-go-back-button">
                {leftButton.icon === HEADER_NAV_BUTTON_PREV ? <Arrow /> : <Close />}
              </IconButton>
            )}
          </Styled.HeaderButton>
          <Styled.HeaderLogo>
            <ManifestLogoSvg />
          </Styled.HeaderLogo>
          <Styled.HeaderButton>{navButton}</Styled.HeaderButton>
        </Flex>
      </Styled.HeaderContainer>
    </Styled.HeaderDiv>
  );
};

export default Header;
